/**
 * Lit la banque de pictogrammes approuvee pour les lecons.
 * La recherche trie les noms avant les mots cles.
 * La liste d'origine reste intacte.
 */
import { TI18nText } from '../../../models/courses/graphicDesign';
import pictograms from '../assets/pictograms.json';
import { normalizeText } from './selectors';

/** Un pictogramme avec son chemin SVG. */
export interface TPictogram { id: string; name: string; category: string; tags: string[]; d: string }
/** Une categorie localisee de pictogrammes. */
export interface TPictogramCategory { id: string; label: TI18nText }
/** Taille native des chemins SVG. */
export const PICTOGRAM_VIEWBOX: number = pictograms.viewBox;
/** Largeur native du trait SVG. */
export const PICTOGRAM_STROKE_WIDTH: number = pictograms.strokeWidth;

const icons: TPictogram[] = pictograms.icons;
const byId = new Map(icons.map(icon => [icon.id, icon]));

/** Liste les categories dans l'ordre de la banque. */
export const listPictogramCategories = (): TPictogramCategory[] =>
  pictograms.categories.map(category => ({ ...category, label: { ...category.label } }));

/** Trouve un pictogramme par son identifiant. */
export const getPictogram = (id: string | undefined): TPictogram | null =>
  id ? byId.get(id) ?? null : null;

const matchRank = (icon: TPictogram, query: string): number => {
  const name = normalizeText(icon.name.replace(/-/g, ' '));
  if (name.startsWith(query)) return 0;
  if (name.includes(query)) return 1;
  return icon.tags.some(tag => normalizeText(tag).includes(query)) ? 2 : 3;
};

/** Cherche par nom ou mot cle, puis applique une limite de resultats. */
export const searchPictograms = (query: string, category?: string, limit = 60): TPictogram[] => {
  const needle = normalizeText(query);
  return icons.filter(icon => (!category || icon.category === category)
    && (!needle || matchRank(icon, needle) < 3))
    .sort((a, b) => (needle ? matchRank(a, needle) - matchRank(b, needle) : 0)
      || a.name.localeCompare(b.name))
    .slice(0, Math.max(0, Math.trunc(limit)));
};
